import { UsersApi } from 'generated/new';

const usersApi = new UsersApi();

export default usersApi;
